module.exports = __webpack_public_path__ + "static/media/kh.2be5f19d.svg";